import React, { FC, ReactChild } from "react"
import Auth from "../context/auth/Auth"
import Footer from "./footer"
import Header from "./header"
import BackgroundImage from "gatsby-background-image"
import { graphql, StaticQuery } from "gatsby"
import { CookiesProvider } from "react-cookie"
import "../../styles/index.scss"
import Location from "../context/location"
import { PageContext } from "gatsby/internal"
import ForbiddenModal from "../forbiddenModal"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"

interface ILayout {
  children: ReactChild
  pageContext: PageContext
}

const Layout: FC<ILayout> = ({ children, pageContext }) => (
  <StaticQuery
    query={graphql`
      query {
        background: file(relativePath: { eq: "hallen-bg.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.background.childImageSharp.fluid
      return (
        <CookiesProvider>
          <Auth>
            <Location>
              <BackgroundImage
                Tag="div"
                fluid={image}
                style={{
                  width: "100vw",
                  minHeight: "100vh",
                  backgroundRepeat: "repeat",
                }}
              >
                <Header pageContext={pageContext} />
                <ForbiddenModal />
                <ToastContainer
                  position="top-center"
                  autoClose={3000}
                  hideProgressBar
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />
                <main>{children}</main>
                <Footer />
              </BackgroundImage>
            </Location>
          </Auth>
        </CookiesProvider>
      )
    }}
  />
)

export default Layout
